// Generated by scripts/build-content-index.cjs from learnTopics.ts and atlasPages.ts.
// Do not edit by hand; it is rebuilt before every `npm start` and `npm run build`.

export type ContentIndexEntry = {
  slug: string;
  title: string;
  summary: string;
};

export const learnIndex: ContentIndexEntry[] = [
  {
    "slug": "microbial-taxonomy",
    "title": "Microbial Taxonomy",
    "summary": "Microbial taxonomy explains how organisms are named, grouped, and related so students can understand why identification systems use genus, species, phenotype, and genetic relationships."
  },
  {
    "slug": "bacterial-structure-genetics-metabolism",
    "title": "Bacterial Structure, Genetics, and Metabolism",
    "summary": "Bacterial structure, genetics, and metabolism explain why organisms stain differently, grow on different media, cause disease, and respond differently to antimicrobials."
  },
  {
    "slug": "host-microorganism-interactions",
    "title": "Host-Microorganism Interactions",
    "summary": "Host-microorganism interactions explain colonization, infection, normal flora, opportunistic disease, immune response, and why the same organism can mean different things in different patients."
  },
  {
    "slug": "clinical-microbiology",
    "title": "Clinical Microbiology Basics",
    "summary": "Clinical microbiology uses specimens, microscopy, culture, antigen tests, serology, and molecular methods to connect a patient problem with a likely infectious cause."
  },
  {
    "slug": "laboratory-safety",
    "title": "Laboratory Safety",
    "summary": "Laboratory safety protects the learner, the bench, the patient, and the community through standard precautions, containment, exposure response, and recognition of high-risk situations."
  },
  {
    "slug": "approaches-diagnosis-infectious-diseases",
    "title": "Approaches to Diagnosis of Infectious Diseases",
    "summary": "Diagnosis of infectious diseases uses a method strategy: direct exam, culture, antigen detection, serology, molecular testing, susceptibility testing, or referral."
  },
  {
    "slug": "evaluation-antimicrobial-activity",
    "title": "Evaluation of Antimicrobial Activity",
    "summary": "Evaluation of antimicrobial activity explains how the laboratory measures inhibition, interprets susceptibility, and connects in vitro results to possible therapy."
  },
  {
    "slug": "bacterial-identification-principles",
    "title": "Principles of Bacterial Identification",
    "summary": "Bacterial identification uses specimen context, Gram stain, colony morphology, growth conditions, and branch-point tests to move from unknown isolate to useful name."
  },
  {
    "slug": "gram-stain",
    "title": "Gram Stain",
    "summary": "The Gram stain separates many bacteria by cell wall staining behavior and gives the bench an early read on morphology, arrangement, and specimen quality."
  },
  {
    "slug": "acid-fast-stain",
    "title": "Acid-Fast Stain",
    "summary": "Acid-fast stains help detect organisms with waxy cell walls, especially Mycobacterium and partially acid-fast organisms such as Nocardia."
  },
  {
    "slug": "culture-media",
    "title": "Culture Media",
    "summary": "Culture media support, select, or differentiate organisms so the lab can recover pathogens and recognize useful colony patterns."
  },
  {
    "slug": "macconkey-agar",
    "title": "MacConkey Agar",
    "summary": "MacConkey agar is selective for many Gram-negative rods and differentiates lactose fermenters from non-lactose fermenters."
  },
  {
    "slug": "catalase-test",
    "title": "Catalase Test",
    "summary": "The catalase test detects catalase enzyme activity by bubbling when hydrogen peroxide is broken down into water and oxygen."
  },
  {
    "slug": "coagulase-test",
    "title": "Coagulase Test",
    "summary": "The coagulase test helps separate Staphylococcus aureus from many coagulase-negative staphylococci."
  },
  {
    "slug": "oxidase-test",
    "title": "Oxidase Test",
    "summary": "The oxidase test detects cytochrome c oxidase and is a key early branch for many Gram-negative organisms."
  },
  {
    "slug": "hanging-drop-preparation",
    "title": "Hanging Drop Preparation",
    "summary": "A hanging drop preparation is a wet mount method used to observe true motility in living organisms."
  },
  {
    "slug": "specimen-quality",
    "title": "Specimen Quality",
    "summary": "Specimen quality determines whether a microbiology result can answer the clinical question."
  },
  {
    "slug": "specimen-collection-transport",
    "title": "Specimen Collection and Transport",
    "summary": "Specimen collection and transport decide whether the laboratory receives the right material in a condition that can answer the clinical question."
  },
  {
    "slug": "respiratory-specimen-quality",
    "title": "Respiratory Specimen Quality",
    "summary": "Respiratory specimen quality helps decide whether a sputum culture represents lower respiratory infection or mostly oral contamination."
  },
  {
    "slug": "antimicrobial-susceptibility-testing",
    "title": "Antimicrobial Susceptibility Testing",
    "summary": "Antimicrobial susceptibility testing estimates whether an organism is likely to respond to an antimicrobial under defined testing conditions."
  },
  {
    "slug": "antimicrobial-resistance-mechanisms",
    "title": "Antimicrobial Resistance Mechanisms",
    "summary": "Resistance mechanisms explain how bacteria survive antimicrobial exposure and why certain phenotypes matter clinically."
  },
  {
    "slug": "staphylococcus-micrococcus",
    "title": "Staphylococcus and Micrococcus",
    "summary": "Staphylococcus and Micrococcus are catalase-positive Gram-positive cocci, but their clinical meaning and bench separation differ."
  },
  {
    "slug": "streptococcus-enterococcus",
    "title": "Streptococcus and Enterococcus",
    "summary": "Streptococcus and Enterococcus are catalase-negative Gram-positive cocci organized by hemolysis, Lancefield grouping, and key bench reactions."
  },
  {
    "slug": "neisseria-moraxella",
    "title": "Neisseria and Moraxella",
    "summary": "Neisseria and Moraxella are oxidase-positive Gram-negative cocci or coccobacilli with important respiratory, genital, and invasive disease associations."
  },
  {
    "slug": "gram-positive-bacilli-overview",
    "title": "Gram-Positive Bacilli Overview",
    "summary": "Gram-positive bacilli include spore-formers, non-spore-formers, branching organisms, and pleomorphic rods with very different clinical meanings."
  },
  {
    "slug": "normal-flora-colonization-infection",
    "title": "Normal Flora, Colonization, and Infection",
    "summary": "A study page for separating expected flora, colonization, contamination, and true infection by body site and host context."
  },
  {
    "slug": "quality-control-reporting-basics",
    "title": "Quality Control and Reporting Basics",
    "summary": "A practical overview of QC, verification, critical values, corrected reports, and why microbiology reports require controlled language."
  },
  {
    "slug": "urine-culture-basics",
    "title": "Urine Culture Basics",
    "summary": "A bench-focused guide to urine specimen types, colony count thinking, common uropathogens, mixed growth, and when culture results need clinical context."
  },
  {
    "slug": "blood-cultures-and-sterile-fluids",
    "title": "Blood Cultures and Sterile Body Fluids",
    "summary": "A practical study page for interpreting positive blood cultures and sterile body fluid cultures by source, collection pattern, Gram stain, contamination risk, and urgency."
  },
  {
    "slug": "microbial-classification-criteria",
    "title": "Microbial Classification Criteria",
    "summary": "A practical map of the evidence used to group, name, and identify microorganisms: visible traits, staining behavior, growth needs, antigenic patterns, resistance behavior, and genetic data."
  },
  {
    "slug": "antibacterial-drug-class-map",
    "title": "Antibacterial Drug Class Map",
    "summary": "A study map of common antibacterial classes by main target: cell wall, protein synthesis, nucleic acid synthesis, membrane disruption, and folate pathway inhibition."
  },
  {
    "slug": "intrinsic-resistance-patterns",
    "title": "Intrinsic Resistance Patterns",
    "summary": "A student guide to natural resistance patterns that are expected for an organism group and should not be treated as surprising acquired resistance."
  },
  {
    "slug": "microscopy-basics",
    "title": "Microscopy Basics",
    "summary": "A foundational page for bright-field, oil immersion, wet mount, fluorescence, and how microscopy supports early organism workup."
  },
  {
    "slug": "microscope-setup-and-smear-reading",
    "title": "Microscope Setup and Smear Reading",
    "summary": "A bench-focused page for microscope setup, bright-field review, oil immersion habits, and reading stained smears without overcalling poor fields."
  },
  {
    "slug": "stain-selection-and-screening",
    "title": "Stain Selection and Screening",
    "summary": "A practical organizer for choosing Gram stain, acid-fast stains, fluorochrome screening, acridine orange, and other direct microscopy approaches."
  },
  {
    "slug": "colony-morphology",
    "title": "Colony Morphology",
    "summary": "A guide to reading colony size, color, texture, hemolysis, odor, pigment, swarming, and purity without overcalling identity."
  },
  {
    "slug": "atmosphere-incubation",
    "title": "Atmosphere and Incubation",
    "summary": "A review page for oxygen tolerance, CO2 needs, temperature, incubation time, and why growth conditions change organism recovery."
  },
  {
    "slug": "media-selection-patterns",
    "title": "Media Selection Patterns",
    "summary": "A student-first guide to why common plates, broths, and special media are used in routine bacteriology and when routine media are not enough."
  },
  {
    "slug": "ast-test-selection-logic",
    "title": "AST Test Selection Logic",
    "summary": "A practical page for deciding why some organism-drug combinations are tested, suppressed, confirmed, or avoided in antimicrobial susceptibility testing."
  },
  {
    "slug": "staphylococcus-species-patterns",
    "title": "Staphylococcus Species Patterns",
    "summary": "A deeper Staphylococcus page for source significance, coagulase-positive versus coagulase-negative patterns, device-associated disease, toxin syndromes, and common bench separation clues."
  },
  {
    "slug": "streptococcus-enterococcus-species-patterns",
    "title": "Streptococcus and Enterococcus Species Patterns",
    "summary": "A deeper page for beta-hemolytic streptococci, S. pneumoniae, viridans group streptococci, nutritionally variant streptococci, Enterococcus, and similar catalase-negative cocci."
  },
  {
    "slug": "bacillus-aerobic-spore-formers",
    "title": "Bacillus and Aerobic Spore-Forming Rods",
    "summary": "A focused page for aerobic spore-forming Gram-positive rods, including Bacillus anthracis safety logic, Bacillus cereus group disease, colony clues, and contaminant-versus-pathogen thinking."
  },
  {
    "slug": "listeria-corynebacterium-coryneform-rods",
    "title": "Listeria, Corynebacterium, and Coryneform Rods",
    "summary": "A study page for non-spore-forming Gram-positive rods that can be dismissed too quickly: Listeria, C. diphtheriae complex, C. jeikeium, C. urealyticum, and other coryneform organisms."
  },
  {
    "slug": "catalase-negative-nonsporeforming-rods",
    "title": "Catalase-Negative Non-Spore-Forming Rods",
    "summary": "A focused page for Erysipelothrix, Arcanobacterium, Gardnerella, Lactobacillus, Leuconostoc-like organisms, and related Gram-positive rods that do not fit the Listeria/Corynebacterium lane."
  },
  {
    "slug": "aerobic-actinomycetes",
    "title": "Aerobic Actinomycetes",
    "summary": "A deeper organizer for branching aerobic Gram-positive rods: Nocardia, Rhodococcus, Gordonia, Tsukamurella, Streptomyces, Actinomadura, Dermatophilus, Nocardiopsis, and related organisms."
  },
  {
    "slug": "gram-negative-rods-overview",
    "title": "Gram-Negative Rods Overview",
    "summary": "A high-level organizer for Enterobacterales, nonfermenters, curved rods, fastidious rods, and environmental Gram-negative rods."
  },
  {
    "slug": "enterobacterales",
    "title": "Enterobacterales",
    "summary": "A study page for common enteric Gram-negative rods, lactose reaction, oxidase, IMViC, H2S, urease, decarboxylases, and stool-pathogen thinking."
  },
  {
    "slug": "nonfermenting-gram-negative-rods",
    "title": "Nonfermenting Gram-Negative Rods",
    "summary": "A review page for Pseudomonas-like organisms, Acinetobacter, Stenotrophomonas, Burkholderia, and other nonfermenter patterns."
  },
  {
    "slug": "curved-water-associated-gram-negative-rods",
    "title": "Curved and Water-Associated Gram-Negative Rods",
    "summary": "A study page for Vibrio, Aeromonas, Chromobacterium, and related water, seafood, wound, and gastrointestinal Gram-negative rod patterns."
  },
  {
    "slug": "fastidious-gram-negative-rods-and-coccobacilli",
    "title": "Fastidious Gram-Negative Rods and Coccobacilli",
    "summary": "A study page for Haemophilus, Pasteurella, HACEK-like organisms, Eikenella, Moraxella-like organisms, and other source-driven Gram-negative coccobacilli."
  },
  {
    "slug": "campylobacter-helicobacter-arcobacter",
    "title": "Campylobacter, Helicobacter, and Arcobacter",
    "summary": "A study page for curved microaerophilic Gram-negative rods: stool pathogens, gastric Helicobacter logic, selective media, oxidase/catalase patterns, and incubation clues."
  },
  {
    "slug": "zoonotic-and-safety-sensitive-gram-negative-agents",
    "title": "Zoonotic and Safety-Sensitive Gram-Negative Agents",
    "summary": "A study page for Bartonella, Brucella, Bordetella, Francisella, and related organisms where animal/vector exposure, biosafety, and public health context shape the workup."
  },
  {
    "slug": "anaerobic-bacteria",
    "title": "Anaerobic Bacteria",
    "summary": "A page for anaerobic specimen quality, oxygen sensitivity, Bacteroides-like groups, Clostridium-like rods, anaerobic cocci, and special media clues."
  },
  {
    "slug": "mycobacteria-actinomycetes",
    "title": "Mycobacteria and Aerobic Actinomycetes",
    "summary": "A student organizer for AFB stains, tuberculosis complex safety logic, nontuberculous mycobacteria, rapid growers, Nocardia, and branching aerobic actinomycetes."
  },
  {
    "slug": "spirochetes-cell-wall-deficient-intracellular-agents",
    "title": "Spirochetes, Cell-Wall-Deficient, and Intracellular Agents",
    "summary": "A page for organisms that do not fit routine Gram stain and plate logic, including Treponema, Borrelia, Leptospira, Mycoplasma, Chlamydia, Rickettsia, and Coxiella."
  },
  {
    "slug": "mycology-overview",
    "title": "Mycology Overview",
    "summary": "A first-pass map for fungal diagnostics: specimen type, direct exam, culture, yeast versus mold, dimorphic fungi, antigen, serology, and molecular methods."
  },
  {
    "slug": "yeasts",
    "title": "Yeasts",
    "summary": "A starter page for Candida, Cryptococcus, Malassezia, Trichosporon, Rhodotorula, and yeast identification clues."
  },
  {
    "slug": "molds-dermatophytes-dimorphic-fungi",
    "title": "Molds, Dermatophytes, and Dimorphic Fungi",
    "summary": "A study organizer for hyaline molds, dematiaceous molds, Mucorales, dermatophytes, and thermally dimorphic fungi."
  },
  {
    "slug": "fungal-diagnostics",
    "title": "Fungal Diagnostic Methods",
    "summary": "A page for fungal stains, culture setup, antigen tests, serology, molecular methods, and when histopathology matters."
  },
  {
    "slug": "parasitology-overview",
    "title": "Parasitology Overview",
    "summary": "A first-pass map for parasite diagnosis by specimen type, life stage, geography, exposure, concentration method, stain, antigen, serology, and molecular testing."
  },
  {
    "slug": "stool-ova-and-parasite",
    "title": "Stool Ova and Parasite Exam",
    "summary": "A practical page for stool O&P collection, preservatives, concentration, permanent stain, and reporting discipline."
  },
  {
    "slug": "intestinal-protozoa",
    "title": "Intestinal Protozoa",
    "summary": "A study page for Giardia, Entamoeba, Dientamoeba, Cryptosporidium, Cyclospora, Cystoisospora, microsporidia, and related intestinal protozoa."
  },
  {
    "slug": "helminths",
    "title": "Helminths",
    "summary": "A student organizer for nematodes, cestodes, trematodes, eggs, larvae, adult worms, tissue disease, and exposure patterns."
  },
  {
    "slug": "blood-and-tissue-parasites",
    "title": "Blood and Tissue Parasites",
    "summary": "A page for blood films, tissue specimens, serology, molecular tests, and parasite patterns outside routine stool O&P."
  },
  {
    "slug": "malaria-blood-films",
    "title": "Malaria and Blood Films",
    "summary": "A focused page for thick and thin blood films, Plasmodium species clues, parasitemia, and urgent reporting logic."
  },
  {
    "slug": "virology-overview",
    "title": "Virology Overview",
    "summary": "A first-pass map for viral structure, specimen timing, NAAT, antigen detection, serology, viral load, genotyping, and public health context."
  },
  {
    "slug": "respiratory-viruses",
    "title": "Respiratory Viruses",
    "summary": "A review page for influenza, RSV, parainfluenza, adenovirus, rhinovirus/enterovirus, seasonal coronaviruses, SARS-CoV-2, and respiratory panels."
  },
  {
    "slug": "herpesviruses",
    "title": "Herpesviruses",
    "summary": "A study page for HSV, VZV, CMV, EBV, HHV-6, latency, reactivation, specimen selection, NAAT, serology, and viral load concepts."
  },
  {
    "slug": "hepatitis-viruses",
    "title": "Hepatitis Viruses",
    "summary": "A page for HAV, HBV, HCV, HDV, HEV, serologic markers, viral load, acute versus chronic infection, and immunity patterns."
  },
  {
    "slug": "hiv-basics",
    "title": "HIV Basics",
    "summary": "A student page for HIV screening, differentiation assays, viral load, CD4 monitoring, resistance testing, and window-period thinking."
  },
  {
    "slug": "congenital-and-cns-viral-infections",
    "title": "Congenital and CNS Viral Infections",
    "summary": "A review page for viral infections where timing, specimen choice, immune status, pregnancy, neonates, and CSF testing are especially important."
  },
  {
    "slug": "molecular-diagnostics-basics",
    "title": "Molecular Diagnostics Basics",
    "summary": "A foundation page for extraction, amplification, target selection, controls, contamination prevention, inhibition, and result interpretation."
  },
  {
    "slug": "pcr-naat",
    "title": "PCR and NAAT",
    "summary": "A study page for PCR, RT-PCR, real-time amplification, cycle threshold concepts, multiplex panels, and result limitations."
  },
  {
    "slug": "sequencing-basics",
    "title": "Sequencing Basics",
    "summary": "A starter page for sequence-based identification, resistance detection, outbreak relatedness, and why database quality matters."
  },
  {
    "slug": "maldi-tof-basics",
    "title": "MALDI-TOF Basics",
    "summary": "A practical page for MALDI-TOF organism identification, colony quality, database matching, score interpretation, and method limitations."
  },
  {
    "slug": "immunoassays",
    "title": "Immunoassays",
    "summary": "A study page for antigen-antibody methods including lateral flow, EIA, agglutination, immunofluorescence, sensitivity, specificity, and cross-reactivity."
  },
  {
    "slug": "serology-interpretation",
    "title": "Serology Interpretation",
    "summary": "A page for IgM, IgG, seroconversion, paired sera, avidity, titers, cross-reactivity, and timing traps."
  },
  {
    "slug": "unknown-isolate-thinking",
    "title": "Unknown Isolate Thinking",
    "summary": "A page for moving from Gram stain and colony clues to the next best branch without randomly collecting tests."
  },
  {
    "slug": "syndrome-to-test-thinking",
    "title": "Syndrome-to-Test Thinking",
    "summary": "A guide to choosing tests from the clinical problem instead of starting with a memorized organism list."
  },
  {
    "slug": "ascp-m-microbiology-study-path",
    "title": "M(ASCP) Microbiology Study Path",
    "summary": "A learner-first study path for M(ASCP) microbiology review before moving into more advanced specialist-level material."
  },
  {
    "slug": "high-yield-comparison-tables",
    "title": "High-Yield Comparison Tables",
    "summary": "A planned collection of Learn Microbes comparison tables for organisms, tests, media, stains, resistance mechanisms, and diagnostic methods."
  },
  {
    "slug": "common-microbiology-exam-traps",
    "title": "Common Microbiology Exam Traps",
    "summary": "A study guide for common traps: confusing colonization with infection, overtrusting one reaction, missing specimen quality, and mixing up similar organisms."
  }
];

export const visualIndex: ContentIndexEntry[] = [
  {
    "slug": "lysine-iron-agar",
    "title": "Lysine Iron Agar Reaction Guide",
    "summary": "An original Learn Microbes bench visual for reading LIA tube patterns without relying on textbook photos."
  },
  {
    "slug": "acetamide-utilization",
    "title": "Acetamide Utilization Visual Guide",
    "summary": "A bench-card style visual for recognizing acetamide utilization as growth plus alkalinization, not just a pretty blue-green tube."
  },
  {
    "slug": "acetate-utilization",
    "title": "Acetate Utilization Visual Guide",
    "summary": "An original acetate slant visual for reading growth and blue alkalinization in enteric and related bench profiles."
  },
  {
    "slug": "bacitracin-susceptibility",
    "title": "Bacitracin Susceptibility (A Disk)",
    "summary": "An original bench-card visual demonstrating bacitracin susceptibility for presumptive Group A strep identification."
  },
  {
    "slug": "bile-esculin",
    "title": "Bile Esculin Reaction Guide",
    "summary": "A visual reference for recognizing esculin hydrolysis in the presence of 4% bile salts as a key marker for Enterococci and Group D Streptococci."
  },
  {
    "slug": "esculin-hydrolysis",
    "title": "Esculin Hydrolysis Visual Guide",
    "summary": "An original bench visual for reading esculin hydrolysis without confusing the plain esculin test with bile esculin."
  },
  {
    "slug": "bile-solubility",
    "title": "Bile Solubility Test Guide",
    "summary": "An original bench reference illustrating the dissolution of Streptococcus pneumoniae colonies under 10% sodium desoxycholate."
  },
  {
    "slug": "fermentation-media",
    "title": "Fermentation Media Visual Guide",
    "summary": "An original broth-tube visual for reading carbohydrate fermentation as acid production, with gas captured separately in a Durham tube."
  },
  {
    "slug": "flagella-stain-wet-mount",
    "title": "Flagella Stain Wet Mount Guide",
    "summary": "An original schematic guide for recognizing flagellar arrangements after wet mount flagella staining."
  },
  {
    "slug": "gelatin-hydrolysis",
    "title": "Gelatin Hydrolysis Visual Guide",
    "summary": "An original deep-tube visual for reading gelatinase activity by liquefaction after chilling."
  },
  {
    "slug": "growth-at-42-c",
    "title": "Growth at 42 C Visual Guide",
    "summary": "An original temperature-tolerance visual for comparing growth at routine temperature with growth at 42 C."
  },
  {
    "slug": "hippurate-hydrolysis",
    "title": "Hippurate Hydrolysis Visual Guide",
    "summary": "An original reagent-tube visual for reading hippurate hydrolysis after ninhydrin is added."
  },
  {
    "slug": "indole-production",
    "title": "Indole Production Visual Guide",
    "summary": "An original reagent-layer visual for reading indole production after Kovac or Ehrlich reagent is added."
  },
  {
    "slug": "leucine-aminopeptidase-lap-test",
    "title": "Leucine Aminopeptidase LAP Test Guide",
    "summary": "An original applicator-tip visual for reading LAP disk reactions after cinnamaldehyde reagent is added."
  },
  {
    "slug": "litmus-milk-medium",
    "title": "Litmus Milk Medium Visual Guide",
    "summary": "An original multi-tube visual for separating litmus milk color reactions from clot, digestion, and peptonization patterns."
  },
  {
    "slug": "butyrate-disk",
    "title": "Butyrate Esterase Disk Guide",
    "summary": "A bench reference for rapid spot-test identification of Moraxella catarrhalis based on butyrate esterase activity."
  },
  {
    "slug": "camp-test",
    "title": "CAMP Test Synergistic Hemolysis Guide",
    "summary": "An original sheep blood agar bench diagram illustrating synergistic beta-hemolysis arrowheads for Group B Streptococci."
  },
  {
    "slug": "catalase-test",
    "title": "Catalase Test Reaction Guide",
    "summary": "An original slide-test bench reference for observing rapid oxygen bubble evolution to differentiate staphylococci from streptococci."
  },
  {
    "slug": "cetrimide-agar",
    "title": "Cetrimide Selective Agar Slant",
    "summary": "A bench reference illustrating growth and fluorescent pigment production of Pseudomonas aeruginosa on selective cetrimide agar."
  },
  {
    "slug": "citrate-utilization",
    "title": "Citrate Utilization (Simmons Citrate)",
    "summary": "An original Simmons Citrate slant guide for reading alkalinization in Enterobacterales and other Gram-negative rod profiles."
  },
  {
    "slug": "coagulase-test",
    "title": "Coagulase Test Guide (Slide and Tube)",
    "summary": "An original Learn Microbes bench guide for evaluating bound coagulase (slide clumping factor) and free coagulase (tube clotting) to identify Staphylococcus aureus."
  },
  {
    "slug": "decarboxylase-tests",
    "title": "Decarboxylase Tests (Moeller's Method)",
    "summary": "An original Learn Microbes bench guide for reading amino acid decarboxylation (Lysine, Ornithine, Arginine) reactions using Moeller's broth and mineral oil."
  },
  {
    "slug": "dnase-test",
    "title": "DNA Hydrolysis (DNase Test Agar)",
    "summary": "An original Learn Microbes bench guide for recognizing deoxyribonuclease (DNase) activity on methyl green agar to differentiate key staphylococci, enterics, and respiratory cocci."
  },
  {
    "slug": "methyl-red-voges-proskauer",
    "title": "Methyl Red / Voges-Proskauer (MRVP) Reaction Guide",
    "summary": "An original four-tube bench visual for reading the Methyl Red and Voges-Proskauer combination test used to separate members of the Enterobacteriaceae family."
  },
  {
    "slug": "microdase-test",
    "title": "Microdase Test (Modified Oxidase)",
    "summary": "An original disk bench visual for reading modified oxidase activity to rapidly differentiate Micrococcus from Staphylococcus among catalase-positive Gram-positive cocci."
  },
  {
    "slug": "motility-testing",
    "title": "Motility Testing",
    "summary": "A bench visual for reading semisolid motility medium deeps containing TTC indicator, used to determine whether bacterial species are motile."
  },
  {
    "slug": "mrs-broth",
    "title": "MRS Broth (de Man, Rogosa, Sharpe)",
    "summary": "An original two-tube bench visual for reading gas production in MRS broth, differentiating gas-producing Leuconostoc sp. from non-gas-producing Lactobacillus sp."
  },
  {
    "slug": "mug-test",
    "title": "MUG Test (4-Methylumbelliferyl-β-D-Glucuronide)",
    "summary": "A UV-fluorescence bench visual for reading the MUG disk test, used to presumptively identify β-glucuronidase-producing E. coli and other Enterobacteriaceae."
  },
  {
    "slug": "nitrate-reduction",
    "title": "Nitrate Reduction Test",
    "summary": "A visual guide to the nitrate reduction test, illustrating the three distinct metabolic endpoints (reduction to nitrite, reduction to nitrogen gas, or no reduction) using a Durham tube and zinc dust."
  },
  {
    "slug": "nitrite-reduction",
    "title": "Nitrite Reduction Test",
    "summary": "A visual guide to the nitrite reduction test, used to determine whether an organism can reduce nitrites to gaseous nitrogen or other nitrogenous compounds."
  },
  {
    "slug": "onpg-test",
    "title": "ONPG Test",
    "summary": "A bench visual for the ONPG test, used to detect β-galactosidase activity to differentiate late lactose fermenters from true non-lactose fermenters."
  },
  {
    "slug": "optochin-test",
    "title": "Optochin (P Disk) Susceptibility Test",
    "summary": "A visual guide to the Optochin susceptibility test, key for the presumptive identification of Streptococcus pneumoniae."
  },
  {
    "slug": "oxidase-test",
    "title": "Oxidase Test (Kovac's Method)",
    "summary": "A bench guide to Kovac's oxidase test, detecting cytochrome c oxidase activity to separate Pseudomonas (positive) from Enterobacteriaceae (negative)."
  },
  {
    "slug": "of-medium",
    "title": "Oxidation/Fermentation (OF) Medium (CDC Method)",
    "summary": "A visual guide to the OF medium test, used to classify bacteria as fermenters, oxidizers, or non-utilizers based on their carbohydrate metabolism under aerobic and anaerobic conditions."
  },
  {
    "slug": "phenylalanine-deaminase",
    "title": "Phenylalanine Deaminase Agar",
    "summary": "A bench guide to Phenylalanine Deaminase Agar, used to differentiate Proteus, Morganella, and Providencia (positive) from other Enterobacteriaceae (negative) by adding ferric chloride."
  },
  {
    "slug": "pyr-test",
    "title": "L-Pyrrolidonyl Arylamidase (PYR) Test",
    "summary": "A bench guide to the PYR test, used for the presumptive identification of Group A streptococci (S. pyogenes) and Enterococci by detecting PYRase activity."
  },
  {
    "slug": "pyruvate-broth",
    "title": "Pyruvate Broth Utilization",
    "summary": "A bench guide to Pyruvate Broth, used to differentiate Enterococcus faecalis (positive) from Enterococcus faecium (negative) based on their ability to utilize pyruvate."
  },
  {
    "slug": "salt-tolerance",
    "title": "Salt Tolerance Test (6.5% NaCl)",
    "summary": "A bench guide to the 6.5% NaCl salt tolerance test, used to differentiate salt-tolerant Enterococci (positive) from salt-sensitive nonenterococci (negative)."
  },
  {
    "slug": "spot-indole",
    "title": "Spot Indole Test",
    "summary": "A bench guide to the rapid Spot Indole test, detecting tryptophanase activity within 20 seconds to quickly differentiate Escherichia coli from Klebsiella."
  },
  {
    "slug": "tsi-test",
    "title": "Triple Sugar Iron Agar (TSI)",
    "summary": "A visual guide to Triple Sugar Iron Agar (TSI), used to determine glucose/lactose/sucrose fermentation, gas production, and hydrogen sulfide (H2S) synthesis in Gram-negative rods."
  },
  {
    "slug": "urease-test",
    "title": "Urease Test (Christensen's Method)",
    "summary": "A bench guide to Christensen's urea agar slant test, used to detect urease activity to rapidly identify Proteus species and differentiate other Enterobacteriaceae."
  },
  {
    "slug": "xv-factor-test",
    "title": "X and V Factor Test",
    "summary": "A diagnostic guide for determining X (hemin) and V (NAD) factor requirements to differentiate and identify Haemophilus species."
  },
  {
    "slug": "mucorales-rhizopus",
    "title": "Mucorales / Rhizopus: Broad Hyphae and Sporangia",
    "summary": "Original bench-card visual for recognizing Mucorales patterns: broad ribbon-like hyphae, sparse septation, right-angle branching, sporangia, and rhizoids."
  },
  {
    "slug": "aspergillus-fumigatus",
    "title": "Aspergillus fumigatus: Septate Hyphae and Conidial Head",
    "summary": "Original bench-card visual for recognizing Aspergillus fumigatus patterns: septate hyphae, acute-angle branching, flask-shaped phialides, and compact columnar conidia."
  },
  {
    "slug": "histoplasma-capsulatum",
    "title": "Histoplasma capsulatum: Intracellular Yeast and Tuberculate Macroconidia",
    "summary": "Original bench-card visual for recognizing Histoplasma: tiny intracellular yeasts in macrophages and tuberculate macroconidia in mold phase."
  },
  {
    "slug": "blastomyces-dermatitidis",
    "title": "Blastomyces dermatitidis: Broad-Based Budding Yeast",
    "summary": "Original bench-card visual for recognizing Blastomyces: large thick-walled yeast with broad-based budding and a mold phase with lateral conidia."
  },
  {
    "slug": "coccidioides-immitis",
    "title": "Coccidioides: Spherule and Arthroconidia",
    "summary": "Original bench-card visual for recognizing Coccidioides: tissue spherules packed with endospores and mold-phase barrel-shaped arthroconidia."
  },
  {
    "slug": "dermatophyte-comparison",
    "title": "Dermatophyte Comparison: Trichophyton, Microsporum, Epidermophyton",
    "summary": "Original bench-card comparison for dermatophyte morphology: microconidia-heavy Trichophyton, spindle macroconidia of Microsporum, and club-shaped macroconidia of Epidermophyton."
  },
  {
    "slug": "candida-albicans-germ-tube",
    "title": "Candida albicans: Germ Tube and Pseudohyphae",
    "summary": "Original bench-card visual for recognizing Candida albicans-style germ tubes and separating true germ tubes from pseudohyphae."
  },
  {
    "slug": "cryptococcus-neoformans-capsule",
    "title": "Cryptococcus neoformans/gattii: Capsule and Narrow-Based Budding",
    "summary": "Original bench-card visual for recognizing encapsulated Cryptococcus yeast and narrow-based budding on direct exam or special stains."
  },
  {
    "slug": "sporothrix-schenckii",
    "title": "Sporothrix schenckii: Cigar Yeast and Flowerette Conidia",
    "summary": "Original bench-card visual for recognizing Sporothrix: cigar-shaped yeast in tissue and flowerette conidia in mold phase."
  },
  {
    "slug": "paracoccidioides-brasiliensis",
    "title": "Paracoccidioides brasiliensis: Multiple Budding Yeast",
    "summary": "Original bench-card visual for recognizing Paracoccidioides multiple budding yeast, often described as a pilot-wheel pattern."
  },
  {
    "slug": "fusarium-sickle-macroconidia",
    "title": "Fusarium spp.: Sickle-Shaped Macroconidia",
    "summary": "Original bench-card visual for recognizing Fusarium: multicelled sickle or canoe-shaped macroconidia with hyaline septate hyphae."
  },
  {
    "slug": "penicillium-talaromyces",
    "title": "Penicillium / Talaromyces: Brush Conidiophores and Fission Yeast",
    "summary": "Original bench-card visual for recognizing Penicillium-like brush conidiophores and Talaromyces marneffei yeast division by fission."
  },
  {
    "slug": "scopulariopsis-rough-conidia",
    "title": "Scopulariopsis spp.: Penicillus-Like Brush and Rough Conidia",
    "summary": "Original bench-card visual for recognizing Scopulariopsis: penicillus-like brush of annellides bearing chains of rough, thick-walled, lemon-shaped conidia."
  },
  {
    "slug": "paecilomyces-tapering-phialides",
    "title": "Paecilomyces spp.: Long Tapering Phialides",
    "summary": "Original bench-card visual for recognizing Paecilomyces: long slender phialides that taper to a fine point, bearing delicate divergent chains of conidia."
  },
  {
    "slug": "scedosporium-lomentospora",
    "title": "Scedosporium / Lomentospora: Flask Cells and Annelloconidia",
    "summary": "Original bench-card visual for recognizing Scedosporium and Lomentospora: flask-shaped conidiogenous cells producing single annelloconidia at the tip on hyaline septate hyphae."
  },
  {
    "slug": "trichosporon-arthroconidia",
    "title": "Trichosporon spp.: Arthroconidia and Blastoconidia",
    "summary": "Original bench-card visual for recognizing Trichosporon: a yeast-like organism producing both rectangular arthroconidia and budding blastoconidia, distinct from Candida."
  },
  {
    "slug": "dematiaceous-alternaria-curvularia",
    "title": "Alternaria vs Curvularia: Dematiaceous Conidia",
    "summary": "Original bench-card visual comparing two dematiaceous molds: Alternaria muriform conidia with a tapered beak versus Curvularia curved conidia with a swollen central cell."
  },
  {
    "slug": "sclerotic-bodies-chromo-vs-phaeo",
    "title": "Sclerotic Bodies: Chromoblastomycosis vs Phaeohyphomycosis",
    "summary": "Original bench-card visual contrasting muriform sclerotic bodies in tissue with dematiaceous septate hyphae, the split that separates chromoblastomycosis from phaeohyphomycosis."
  },
  {
    "slug": "bipolaris-exserohilum-poroconidia",
    "title": "Bipolaris vs Exserohilum: Poroconidia and Hilum",
    "summary": "Original bench-card visual comparing two dematiaceous molds with multicelled poroconidia on geniculate conidiophores, separated by the protruding hilum of Exserohilum."
  },
  {
    "slug": "cladosporium-shield-cells",
    "title": "Cladosporium: Shield Cells and Fragile Chains",
    "summary": "Original bench-card visual for recognizing Cladosporium: erect branching conidiophores with shield-shaped cells and fragile chains of elliptical dematiaceous blastoconidia."
  },
  {
    "slug": "chromoblastomycosis-agents",
    "title": "Chromoblastomycosis Agents: Sporulation Types",
    "summary": "Original bench-card visual comparing how three chromoblastomycosis agents sporulate: Phialophora collarette phialides, Fonsecaea mixed denticulate types, and Cladophialophora long fragile chains."
  },
  {
    "slug": "exophiala-black-yeast",
    "title": "Exophiala / Hortaea: Black Yeast to Annellophores",
    "summary": "Original bench-card visual for recognizing black yeast morphology: early annellidic budding yeast cells maturing to tapered tube-like annellophores in Exophiala and Hortaea."
  },
  {
    "slug": "aspergillus-species-comparison",
    "title": "Aspergillus Species: Conidial Head Comparison",
    "summary": "Original bench-card visual comparing Aspergillus conidial heads: fumigatus compact columnar, niger biseriate radiate, flavus variable, and terreus with accessory aleurioconidia."
  },
  {
    "slug": "viral-cytopathic-effect-panel",
    "title": "Viral Cytopathic Effect: Culture Pattern Panel",
    "summary": "Original bench-card visual for reviewing common cytopathic effect patterns in viral culture: rounding, syncytia, plaques, and inclusion-like change."
  },
  {
    "slug": "herpesvirus-cpe",
    "title": "Herpesvirus-Style CPE: Multinucleation and Molding",
    "summary": "Original bench-card visual for reviewing herpesvirus-style cytopathic effect, including multinucleation, nuclear molding, and marginated chromatin."
  },
  {
    "slug": "cmv-owl-eye-inclusion",
    "title": "CMV Inclusion Pattern: Owl-Eye Study Card",
    "summary": "Original bench-card visual for recognizing the classic cytomegalovirus inclusion pattern as a morphology review anchor."
  },
  {
    "slug": "respiratory-virus-naat-panel",
    "title": "Respiratory Virus NAAT Panel: Result Logic",
    "summary": "Original bench-card visual for reviewing respiratory virus molecular panel logic from specimen to target result."
  },
  {
    "slug": "hepatitis-b-serology-patterns",
    "title": "Hepatitis B Serology: Marker Pattern Study Card",
    "summary": "Original bench-card visual for learning common hepatitis B serology marker patterns without turning them into a clinical management algorithm."
  },
  {
    "slug": "hiv-screening-algorithm",
    "title": "HIV Screening Algorithm: Study Flow",
    "summary": "Original bench-card visual for reviewing the common HIV laboratory screening flow: Ag/Ab screen, differentiation assay, and NAT follow-up concept."
  },
  {
    "slug": "viral-em-morphology-panel",
    "title": "Electron Micrograph Morphology: Four Classic Silhouettes",
    "summary": "Original bench-card visual for reviewing classic negative-stain electron micrograph shapes used as morphology anchors: rotavirus wheel, coronavirus corona, adenovirus icosahedron, and small round structured virus."
  },
  {
    "slug": "giardia-lamblia",
    "title": "Giardia lamblia: Trophozoite and Cyst",
    "summary": "Original bench-card visuals for recognizing Giardia trophozoite and cyst morphology in wet preparations and stained stool concentrates, including median body placement and nuclear arrangement."
  },
  {
    "slug": "cryptosporidium-oocyst",
    "title": "Cryptosporidium: Modified Acid-Fast Oocyst",
    "summary": "Original bench-card visual for recognizing Cryptosporidium oocysts on modified acid-fast stain: staining intensity variability, thick-wall vs. thin-wall biology, and yeast as the primary morphologic mimic."
  },
  {
    "slug": "entamoeba-histolytica",
    "title": "Entamoeba histolytica: Trophozoite and Cyst",
    "summary": "Original bench-card visuals for recognizing E. histolytica/dispar trophozoite and cyst morphology, with nuclear structure detail, erythrophagocytosis as the pathogenicity clue, and E. coli chromatoid comparison."
  },
  {
    "slug": "trichomonas-vaginalis",
    "title": "Trichomonas vaginalis: Wet Mount and Stained",
    "summary": "Original bench-card visuals for recognizing Trichomonas vaginalis by wet mount motility pattern and stained morphology: 4 free anterior flagella, 1 recurrent flagellum forming the undulating membrane, and the rigid axostyle."
  },
  {
    "slug": "enterobius-vermicularis-egg",
    "title": "Enterobius vermicularis: Perianal Tape Prep Egg",
    "summary": "Original bench-card visuals for recognizing Enterobius vermicularis (pinworm) eggs on perianal tape prep: asymmetric D-shape, thin colorless shell, and visible internal larva."
  },
  {
    "slug": "strongyloides-stercoralis-larva",
    "title": "Strongyloides stercoralis: Rhabditiform Larva",
    "summary": "Original bench-card visuals for recognizing Strongyloides stercoralis rhabditiform larva in fresh stool: short buccal channel and visible genital primordium as the key morphologic clues against hookworm larval mimic."
  },
  {
    "slug": "hookworm-egg",
    "title": "Hookworm: Oval Thin-Shelled Egg with Morula",
    "summary": "Original bench-card visuals for recognizing hookworm eggs (Ancylostoma duodenale and Necator americanus) in stool: oval, thin-shelled, with segmented morula and a clear space between shell and embryo."
  },
  {
    "slug": "trichuris-trichiura-egg",
    "title": "Trichuris trichiura: Barrel-Shaped Egg with Bipolar Plugs",
    "summary": "Original bench-card visuals for recognizing Trichuris trichiura (whipworm) eggs in stool: barrel-shaped brown shell with hyaline bipolar plugs at each end - one of the most visually distinctive helminth eggs."
  },
  {
    "slug": "plasmodium-falciparum-smear",
    "title": "Plasmodium falciparum: Thin Blood Smear",
    "summary": "Original bench-card visuals for recognizing Plasmodium falciparum on Giemsa-stained thin blood smear: delicate ring forms, multiple rings per RBC, accole (applique) forms, and banana-shaped gametocytes as diagnostic anchors."
  },
  {
    "slug": "babesia-ring-forms",
    "title": "Babesia spp.: Ring Forms and Maltese Cross Tetrad",
    "summary": "Original bench-card visuals for recognizing Babesia spp. on Giemsa-stained thin blood smear: small pleomorphic ring forms, extracellular merozoites, and the pathognomonic Maltese cross (tetrad) arrangement."
  },
  {
    "slug": "trypanosoma-trypomastigote",
    "title": "Trypanosoma cruzi: Trypomastigote in Blood Film",
    "summary": "Original bench-card visuals for recognizing Trypanosoma cruzi on Giemsa-stained thin blood film: C- or U-shaped trypomastigote with large posterior kinetoplast, undulating membrane, and single anterior flagellum."
  },
  {
    "slug": "toxoplasma-gondii-tachyzoite",
    "title": "Toxoplasma gondii: Tachyzoite and Tissue Cyst",
    "summary": "Original bench-card visuals for recognizing Toxoplasma gondii tachyzoites and bradyzoite-filled tissue cysts: crescent-shaped tachyzoites, nucleus toward the broad end, and bradyzoites in PAS-positive tissue cysts."
  },
  {
    "slug": "leishmania-amastigotes",
    "title": "Leishmania spp.: Amastigotes in Tissue",
    "summary": "Original bench-card visuals for recognizing Leishmania donovani amastigotes (Leishman-Donovan bodies) in macrophages/Kupffer cells on Giemsa stain: small round organisms with nucleus and rod-shaped kinetoplast side by side."
  },
  {
    "slug": "ascaris-lumbricoides-egg",
    "title": "Ascaris lumbricoides: Mammillated and Decorticate Eggs",
    "summary": "Bench-card visuals for Ascaris lumbricoides eggs: the bile-stained mammillated (bumpy) fertile egg - the most recognizable helminth egg in clinical parasitology - and the decorticate variant that has lost its outer coat."
  },
  {
    "slug": "trichostrongylus-egg",
    "title": "Trichostrongylus spp.: Elongated Hookworm-Like Egg",
    "summary": "Bench-card visuals for Trichostrongylus spp. eggs: larger, more elongated, and with at least one tapered end compared to hookworm. Advanced morula when passed. A size-matched hookworm mimic that requires careful measurement to distinguish."
  },
  {
    "slug": "trichinella-spiralis-larva",
    "title": "Trichinella spiralis: Encysted Larva in Striated Muscle",
    "summary": "Bench-card visuals for Trichinella spiralis diagnosis: the coiled larva encapsulated in a nurse cell within striated muscle, seen on compressed muscle squash preparation and on H&E tissue section."
  },
  {
    "slug": "microfilariae-blood-smear",
    "title": "Microfilariae: Sheathed vs. Unsheathed - Blood Smear",
    "summary": "Bench-card visuals for distinguishing microfilariae in thick blood smears: sheath presence and nuclei in the tail differentiate Wuchereria bancrofti (sheathed, no tail nuclei) from Loa loa (sheathed, nuclei to tail tip). Brugia malayi and Onchocerca volvulus noted for comparison."
  },
  {
    "slug": "taenia-spp-egg",
    "title": "Taenia spp. Egg and Gravid Proglottid",
    "summary": "Bench-card visuals for Taenia species identification: the round radially-striated embryophore egg (morphologically identical between T. solium and T. saginata) and the gravid proglottid uterine branch count that separates the two clinically critical species."
  },
  {
    "slug": "paragonimus-westermani-egg",
    "title": "Paragonimus westermani and Clonorchis sinensis Eggs",
    "summary": "Bench-card visuals for lung and liver trematode eggs: Paragonimus westermani (large, golden-brown, operculated with shouldered rim) found in sputum or stool, and Clonorchis sinensis (tiny flask-shaped, operculated with prominent shoulders and abopercular knob) found in stool."
  },
  {
    "slug": "schistosoma-egg",
    "title": "Schistosoma spp. Eggs: Spine Location by Species",
    "summary": "Bench-card visuals for Schistosoma species identification by egg spine position: S. mansoni (large, prominent lateral spine), S. haematobium (terminal spine), and S. japonicum (small, rudimentary lateral spine or none)."
  },
  {
    "slug": "hymenolepis-nana-egg",
    "title": "Hymenolepis nana and H. diminuta Eggs",
    "summary": "Bench-card visuals for dwarf and rat tapeworm egg identification: H. nana (thin-shelled, 6 hooklets, polar filaments in the space between oncosphere and eggshell - diagnostic) versus H. diminuta (same size range but no polar filaments, larger eggs)."
  },
  {
    "slug": "diphyllobothrium-latum-egg",
    "title": "Diphyllobothrium latum: Operculated Fish Tapeworm Egg",
    "summary": "Bench-card visuals for the fish tapeworm egg: Diphyllobothrium latum produces the largest egg of the common intestinal cestodes - broadly oval, operculated, yellow-brown, with a small knob at the abopercular end and an unembryonated interior."
  },
  {
    "slug": "echinococcus-granulosus-hydatid",
    "title": "Echinococcus granulosus: Hydatid Sand and Protoscoleces",
    "summary": "Bench-card visuals for Echinococcus granulosus (hydatid disease) laboratory findings: protoscoleces in hydatid fluid (with suckers and hooklets), brood capsules, and the thick laminated cyst wall in tissue - not detected by routine stool O&P."
  },
  {
    "slug": "plasmodium-species-comparison",
    "title": "Plasmodium Species Comparison: vivax, ovale, malariae vs. falciparum",
    "summary": "Bench-card comparison of the four major Plasmodium species on Giemsa-stained thin blood smear: RBC enlargement, Schüffner dots, trophozoite morphology, schizont characteristics, and gametocyte shape."
  },
  {
    "slug": "cyclospora-cystoisospora-maf",
    "title": "Cyclospora vs. Cystoisospora on Modified Acid-Fast",
    "summary": "Bench-card comparison of Cyclospora cayetanensis and Cystoisospora belli oocysts on modified acid-fast stain: size difference (8-10 um vs. 25-30 um), staining intensity variability (Cyclospora), and sporoblast count differentiation."
  },
  {
    "slug": "entamoeba-comparison-panel",
    "title": "Entamoeba Comparison Panel: E. histolytica/dispar, E. coli, E. hartmanni",
    "summary": "Bench-card comparison of the three most common Entamoeba species in stool: E. histolytica/dispar (pathogenic, 4-nucleated cyst, central karyosome, blunt chromatoids), E. coli (nonpathogenic, 8-nucleated cyst, eccentric karyosome, splintered chromatoids), and E. hartmanni (nonpathogenic, small <10 um)."
  },
  {
    "slug": "operculated-egg-comparison",
    "title": "Operculated Trematode Egg Comparison: Diphyllobothrium, Paragonimus, Fasciola, Clonorchis",
    "summary": "Bench-card comparison of the four common operculated helminth eggs: Diphyllobothrium latum (~65 um, abopercular knob), Paragonimus westermani (~90 um, shouldered operculum), Fasciola hepatica/Fasciolopsis buski (~140 um, largest, thin shell), and Clonorchis/Opisthorchis (~30 um, smallest, shoulder rim)."
  },
  {
    "slug": "blastocystis-hominis-forms",
    "title": "Blastocystis hominis: Central Body, Granular, and Ameboid Forms",
    "summary": "Bench-card visuals for recognizing Blastocystis hominis in stool: the dominant central body form (large central vacuole, peripheral nuclei), granular form, and ameboid form; size range 6-40 um; clinical significance and report context."
  },
  {
    "slug": "dientamoeba-fragilis-trophozoite",
    "title": "Dientamoeba fragilis: Binucleate Trophozoite",
    "summary": "Bench-card visuals for recognizing Dientamoeba fragilis trophozoite: binucleate (80% of organisms), fragmented chromatin within nucleus, no cyst stage, delicate cytoplasm, and association with Enterobius co-infection."
  },
  {
    "slug": "clonorchis-opisthorchis-egg",
    "title": "Clonorchis sinensis / Opisthorchis spp.: Operculated Biliary Fluke Egg",
    "summary": "Bench-card visuals for recognizing Clonorchis sinensis and Opisthorchis spp. eggs: the smallest common operculated helminth egg (~28-35 um), flask or vase shape, prominent shoulder rim at the opercular end, tiny knob at the abopercular end, and bile-staining."
  },
  {
    "slug": "fasciolopsis-fasciola-comparison",
    "title": "Fasciola hepatica vs. Fasciolopsis buski: Large Operculated Egg Comparison",
    "summary": "Bench-card comparison of the two largest operculated helminth eggs: Fasciola hepatica (liver fluke, ~130-150 um, thin shell, biliary disease) and Fasciolopsis buski (intestinal giant fluke, ~130-140 um, thin shell) - morphologically essentially identical, differentiated by clinical context and geographic exposure."
  },
  {
    "slug": "dipylidium-caninum-egg-packet",
    "title": "Dipylidium caninum: Egg Packets and Cucumber-Seed Proglottids",
    "summary": "Bench-card visuals for Dipylidium caninum (dog/cat tapeworm): egg capsules/packets (5-30 oncospheres per capsule), cucumber-seed shaped proglottids, and flea/louse transmission - the most common tapeworm of dogs and cats, occasional human infections in children."
  },
  {
    "slug": "taenia-scolex-comparison",
    "title": "Taenia Scolex Comparison: T. solium vs. T. saginata",
    "summary": "Bench-card comparison of Taenia solium (pork tapeworm) and T. saginata (beef tapeworm) scoleces: T. solium has 4 suckers + rostellum with 2 rows of hooks (armed); T. saginata has 4 suckers only, NO rostellum, NO hooks (unarmed). Critical distinction for cysticercosis risk assessment."
  }
];
